import Auth from '@/fstore/auth';
import User from '@/fstore/collections/User';

const getAuth = async ({ commit, dispatch, state, rootState }) => {
  const status = Auth.ref.currentUser;

  if (!status)
    return;

  if (!state.data.uid) {
    const user = await User.getById(status.uid)
    commit('setData', user)
  }

  if ( state.data.role && state.data.role.includes('company') && !rootState.company.data.uid) {
    await dispatch('company/getByUserId', state.data.uid, { root: true });
  }
}

const login = async ({ commit, dispatch }, credentials) => {
  dispatch('app/setOverlay', true, { root: true });
  const status = await Auth.login(credentials);
  commit('setData', status.data);
  dispatch('app/setOverlay', false, { root: true });
  return status
}

const update = async ({ commit, dispatch }, data) => {
  dispatch('app/setOverlay', true, { root: true });
  await User.update(data.uid, data)
  dispatch('app/setOverlay', false, { root: true });
}

const reset = ({ commit }) => {
  commit('setData', {});
}

const logout = async ({ dispatch, rootState }) => {
  await Auth.logout();
  localStorage.removeItem("companyId");

  for (const store in rootState) {
    dispatch(`${store}/reset`, null, { root: true });
  }
}

export default {
  getAuth,
  login,
  update,
  logout,
  reset
}
